import { render } from "./AgentIndex.vue?vue&type=template&id=4a9b217c&scoped=true"
import script from "./AgentIndex.vue?vue&type=script&lang=js"
export * from "./AgentIndex.vue?vue&type=script&lang=js"

import "./AgentIndex.vue?vue&type=style&index=0&id=4a9b217c&scoped=true&lang=scss"

import exportComponent from "D:\\由创科技-ljx\\apicode\\github\\DY.Web\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a9b217c"]])

export default __exports__